/**
 * Shared HTTP client for the standalone tourCollaborators Cloud Function.
 * One endpoint, four actions — see _the3daapp-fe/cloud-functions/collaborators-api.
 */

import { getAuth } from 'firebase/auth';

export async function callCollaboratorsApi<T>(
  body: Record<string, unknown>,
): Promise<T> {
  const endpoint = process.env.REACT_APP_COLLABORATORS_API_URL;
  if (!endpoint) {
    throw new Error('REACT_APP_COLLABORATORS_API_URL is not configured');
  }

  const idToken = await getAuth().currentUser?.getIdToken();
  if (!idToken) {
    throw new Error('Not authenticated');
  }

  const response = await fetch(endpoint, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${idToken}`,
    },
    body: JSON.stringify(body),
  });

  if (!response.ok) {
    let message = '';
    try {
      const errBody = await response.json();
      message = errBody?.error || errBody?.message || '';
    } catch {
      /* ignore */
    }
    throw new Error(
      message || `collaborators endpoint returned ${response.status}`,
    );
  }

  return response.json() as Promise<T>;
}
